var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MStateBox,{attrs:{"loading":_setup.investment_activity.loading,"empty":_setup.isEmpty}},[_vm._l((_setup.displayActivityList),function(item,index){return _c(_setup.RowCardInfo,{key:index,attrs:{"item":item,"formatter":_setup.formatter}})}),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }